<template>
  <div class="card" @click="showCard" v-show="visible">
    <div class="content">
      <div class="name">
        <div class="category">
          {{ team.category.max_age }}
        </div>
        {{ team.name }}
      </div>
      <div class="info">
        <div class="players">
          {{ $t("titles.players") }}: {{ team.players }}
        </div>
        <div class="staff">{{ $t("titles.staff") }}: {{ team.staff }}</div>
        <div class="companion">
          {{ $t("titles.acompanyants") }}: {{ team.acompanyants }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  components: {},
  props: { team: Object, club: Object, event: Object, show: Boolean },
  data() {
    return {};
  },
  computed: {
    visible: function() {
      return typeof this.show === "undefined" || this.show;
    }
  },
  methods: {
    showCard() {
      var team = { ...this.team };

      team.club = {
        id: this.club.id,
        name: this.club.name,
        shield: this.club.shield
      };

      team.event = {
        id: this.event.id,
        name: this.event.name,
        edition: this.event.edition
      };

      this.$router.push(
        this.$root.entityUrl("team", this.team.id, this.event.id)
      );
      //   this.$card.team( team, true, team.club.id );
    }
  },
  created() {
    var self = this;
    if (
      typeof this.$store.getters["events/getEventByID"](this.event.id) ===
      "undefined"
    ) {
      this.$store.dispatch(
        "events/loadByName",
        this.event.name.toLowerCase() + this.event.edition.substring(0, 2)
      );
    }
  },

  filters: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card {
  padding: 15px;
  border-radius: 3px;
  margin: 15px 1%;
  overflow: hidden;
  background: url("/img/right-arrow.svg") no-repeat right 10px center #fff;
  background-size: 20px;
  float: left;
  cursor: pointer;
  width: 48%;

  border: 1px solid #ddd;
  border-left: 5px solid $main-color;

  .content {
    width: calc(100% - 20px);
    float: left;
  }

  .name {
    margin: 0 auto;
    font-size: 18px !important;
    margin-bottom: 5px;
    font-family: Roboto-Bold;
    color: $main-color;
  }

  .category {
    display: inline-block;
    width: fit-content;
    color: #fff;
    background: #333;
    padding: 2px 8px;
    border-radius: 3px;
  }
  .info {
    width: fit-content;
    display: inline-block;
    position: relative;
    margin-left: 0px;
    display: block;
    height: 25px;

    .players {
      // background-image: url( /img/player.svg );
      background-size: 32px;
      background-position: left center;
      background-repeat: no-repeat;
      padding-left: 0px;
      display: inline-block;
      font-size: 14px;
    }
    .staff {
      margin-left: 20px;
      // background-image: url( /img/player.svg );
      background-size: 32px;
      background-position: left center;
      background-repeat: no-repeat;
      padding-left: 20px;
      display: inline-block;
      font-size: 14px;
    }
    .companion {
      margin-left: 20px;
      // background-image: url( /img/player.svg );
      background-size: 32px;
      background-position: left center;
      background-repeat: no-repeat;
      padding-left: 20px;
      display: inline-block;
      font-size: 14px;
    }
  }
}
</style>
